import { has } from 'lodash'
import React, { useContext } from 'react'
import * as PropTypes from 'prop-types'
import { MenuContext } from '../../contexts/menuContext'

const TabsMenuTree = ({ menu, activeMenu, changeOnClickMenu, menuTrigger }) => {
  const [, , , changeRightSidebar] = useContext(MenuContext)
  return (
    <ul className="nav nav-tabs" id="maintabs" role="tablist">
      {menu.map((items) => {
        if (has(items, 'link')) {
          return (
            <li key={items.key} className="nav-item">
              <a
                className={activeMenu === items.key ? 'nav-link active' : 'nav-link'}
                data-reference={items.key}
                href={items.link}
                role="tab"
                aria-selected="true"
                target="_blank"
              >
                {items.name}
              </a>
            </li>
          )
        }

        return (
          <li key={items.key} className="nav-item">
            <a
              onClick={(event) => {
                changeOnClickMenu(items.key, menuTrigger)
                changeRightSidebar(false)
                event.preventDefault()
              }}
              className={activeMenu === items.key ? 'nav-link active' : 'nav-link'}
              data-toggle="tab"
              data-reference={items.key}
              href={`#${items.key}`}
              role="tab"
              aria-selected="true"
            >
              {items.name}
            </a>
          </li>
        )
      })}
    </ul>
  )
}

TabsMenuTree.defaultProps = {
  menu: [],
  menuTrigger: false,
  activeMenu: '',
}

TabsMenuTree.propTypes = {
  menu: PropTypes.arrayOf(PropTypes.shape({})),
  activeMenu: PropTypes.string,
  menuTrigger: PropTypes.bool,
  changeOnClickMenu: PropTypes.func.isRequired,
}

export default TabsMenuTree
